// extracted by mini-css-extract-plugin
export var headerBlock = "switchableImage-module--header-block--56g3Q";
export var imageBlock = "switchableImage-module--image-block--v0tZv";
export var switchableImage = "switchableImage-module--switchable-image--cwIhq";